import { createUserWithEmailAndPassword } from "firebase/auth";
import { arrayUnion, doc, setDoc, updateDoc } from "firebase/firestore";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import { owneruid } from "../constant/services";
import { auth, db } from "../firebase-key";

const Signup = () => {
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      // Firebase Auth signup
      const userCred = await createUserWithEmailAndPassword(
        auth,
        data.email,
        data.password
      );
      const uid = userCred.user.uid;

      // Store user record with other fields empty
      await setDoc(doc(db, "users", uid), {
        uid,
        name: data.name,
        email: data.email,
        phone: data.phone,
        status: "ACTIVE",
        employeeId: [owneruid],

        // add all future fields as empty
        firm_name: "",
        project_work: "",
        project_address: "",
        gov_scheme_name: "",
        loan_amount: "",
        customer_name: "",
        dob: "",
        pan: "",
        aadhaar: "",
        udyam: "",
        gst: "",
        mobile1: data.phone,
        mobile2: "",
        email_alt: "",
        address: "",
        pincode: "",

        created_at: new Date(),
      });

       // ADD CUSTOMER TO OWNER'S customers[] ARRAY 🔥
    await updateDoc(doc(db, "teams", owneruid), {
      customers: arrayUnion(uid),
    });

      toast.success("Account created successfully 🎉");
      window.location.href = "/login";

    } catch (err) {
      console.error(err);
      toast.error("Signup failed. Try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex py-28 justify-center items-center bg-[#f7f9fc] px-4">
      <ToastContainer />

      <div className="w-full max-w-md bg-white p-10 rounded-2xl shadow-lg border border-gray-200">
        <h1 className="text-3xl font-semibold text-center text-gray-800 mb-6">
          Create Your Account ✨
        </h1>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">

          <Input label="Full Name" name="name" register={register} errors={errors} />

          <Input 
            label="Email"
            name="email"
            type="email"
            register={register}
            errors={errors}
            rules={{
              required: "Email required",
              pattern: { value: /\S+@\S+\.\S+/, message: "Invalid email" }
            }}
          />

          <Input 
            label="Phone Number"
            name="phone"
            type="number"
            register={register}
            errors={errors}
            rules={{
              required: "Phone number required",
              minLength: { value: 10, message: "Must be 10 digits" },
              maxLength: { value: 10, message: "Must be 10 digits" }
            }}
          />

          <Input 
            label="Password"
            name="password"
            type="password"
            register={register}
            errors={errors}
            rules={{
              required: "Password required",
              minLength: { value: 6, message: "Min 6 characters" }
            }}
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
          >
            {loading ? "Creating Account..." : "Signup"}
          </button>
        </form>

        <p className="text-center text-gray-600 mt-5">
          Already have an account?{" "}
          <a href="/login" className="text-blue-600 hover:underline">Login</a>
        </p>
      </div>
    </div>
  );
};

const Input = ({ label, name, register, errors, type = "text", rules = {} }) => (
  <div>
    <label className="text-sm text-gray-700">{label}</label>
    <input
      type={type}
      {...register(name, { required: `${label} required`, ...rules })}
      className="w-full mt-1 px-4 py-3 rounded-lg bg-gray-50 border border-gray-300 outline-none"
      placeholder={label}
    />
    {errors[name] && (
      <p className="text-red-500 text-sm">{errors[name].message}</p>
    )}
  </div>
);

export default Signup;
